import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import VindOnzeShop from "./sections/VindOnzeShop";
import StelEenVraag from "./sections/StelEenVraag";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <VindOnzeShop />
      <StelEenVraag />
      <Footer />
    </div>;
}